import * as React from 'react'
import { memo } from 'react'
import { Link } from 'react-router'
import { getPathFromRouteId } from '../../core/utils/route-utils'
import { RouteId } from '../../core/routing/router/route-ids'
import { useTranslation } from 'react-i18next'
import { VtmnCard } from '@vtmn/react'

const ExtendedAnalysis: React.FunctionComponent = () => {
  const { t } = useTranslation()
  return (
    <>
      <div className="mg-reporting-container">
        <section className="mg-reporting-list">
          <Link to={getPathFromRouteId(RouteId.DayByDayHourByHour)}>
            <VtmnCard
              img={<span className="material-icons-outlined">timelapse</span>}
              title={t('general.pages.piloting.days_hours')}
              variant="side-image"
              fullImage={true}
            >
              {t('general.pages.description.days_hours')}
            </VtmnCard>
          </Link>
          <Link to={getPathFromRouteId(RouteId.EmbeddedWorkshopPerformance)}>
            <VtmnCard
              img={<span className="material-icons-outlined">handyman</span>}
              title={t('general.pages.settings.embedded_workshop_performance')}
              variant="side-image"
              fullImage={true}
            >
              {t('general.pages.description.embedded_workshop_performance')}
            </VtmnCard>
          </Link>
          <Link to={getPathFromRouteId(RouteId.EmbeddedRentalPerformance)}>
            <VtmnCard
              img={<span className="material-icons-outlined">change_circle</span>}
              title={t('general.pages.settings.embedded_rental_performance')}
              variant="side-image"
              fullImage={true}
            >
              {t('general.pages.description.embedded_rental_performance')}
            </VtmnCard>
          </Link>
          <Link to={getPathFromRouteId(RouteId.EmbeddedDataExtraction)}>
            <VtmnCard
              img={<span className="material-icons-outlined">analytics</span>}
              title={t('general.pages.settings.embedded_data_extraction')}
              variant="side-image"
              fullImage={true}
            >
              {t('general.pages.description.embedded_data_extraction')}
            </VtmnCard>
          </Link>
        </section>
      </div>
    </>
  )
}

export default memo(ExtendedAnalysis)
